const nameSpace = 'pagePermission'

export const mutations = {
  SET_PERMISSION_LEVEL: `${nameSpace}/SET_PERMISSION_LEVEL`,
}

export const actions = {
  SET_PERMISSION_LEVEL: `${nameSpace}/SET_PERMISSION_LEVEL`,
}

export const getters = {
  permissionLevel: `${nameSpace}/permissionLevel`,
}
